export const RewardsStatsigFeatureGate = {
  PointsLedgerUIEnabled: 'points_ledger_ui_enabled',
} as const
